export enum RewardType {
    COINS = 'coins',
    BOMB = 'bomb',
    JOKER = 'joker',
    UNDO = 'undo',
    BULLSEYE = 'bullseye',
    SHUFFLE = 'shuffle',
    NONE = 'none',
    PLUS_FIVE_CARDS = 'plus_five_cards',
    THREE_STAR_REWARD = 'three_star_reward',
    PRIZE_WHEEL_SPIN = 'prize_wheel_spin',
    CARDS = 'cards',
    OTHER = 'other',
    // WARNING: this value is also used as storage key
    FREE_PLAY = 'free_play',
    PET = 'pet',
    PREMIUM_SPIN = 'premium_spin',

    PRE_BOOSTER_REMOVE_THREE = 'pre_booster_remove_three',
    PRE_BOOSTER_JOKER = 'pre_booster_joker',
    PRE_BOOSTER_CANISTER = 'pre_booster_canister',

    FARM_AREA = 'farm_area',
    FARM_ITEM = 'farm_item',

    PLINKO_TOKEN = 'plinko_token',
}
